import React from "react";
import { Field, FormikTouched } from "formik";
import { cleanPhoneNumberInput } from "../../../../../utils/validationUtils";

interface Props {
  value: string;
  name: any;
  placeholder: string;
  type: any;
  inputMode?: string;
  pattern?: string;
  onChange: () => void;
  label: any;
  errors: any;
  touched: FormikTouched<any>;
  optional?: boolean;
}

const LabelInsideInputController = (props: Props) => {
  if (props.value) {
    props.errors[props.name] = undefined;
  }

  const limitPhoneDigits = (raw: string) => {
    const cleaned = cleanPhoneNumberInput(raw);
    let digits = 0;
    let out = "";
    for (const ch of cleaned) {
      if (/\d/.test(ch)) {
        if (digits >= 15) continue; // enforce max 15 digits
        digits++;
      }
      out += ch;
    }
    return out;
  };

  const showError =
    !props.optional &&
    props.errors &&
    props.errors[props.name] &&
    props.touched[props.name];

  return (
    <div className="text-field-section">
      <div className="d-flex my-2">
        {props.label !== null ? (
          <>
            <label htmlFor={props.name}>
              {props.label}{" "}
              {!props.optional && <span className="required">*</span>}
            </label>
          </>
        ) : null}
      </div>

      <div className={`input-container-wrapper ${showError ? "error" : ""}`}>
        <Field
          name={props.name}
          className="input-control"
          placeholder={props.value ? props.value : props.label}
          type={props.type}
          inputMode={props.inputMode ? props.inputMode : "text"}
          pattern={props.pattern ? props.pattern : undefined}
          onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
            if (props.type === "tel") {
              const cleaned = cleanPhoneNumberInput(e.target.value);
              if (cleaned !== e.target.value) e.target.value = cleaned;
              const limited = limitPhoneDigits(e.target.value);
              if (limited !== e.target.value) e.target.value = limited;
            }
          }}
        />
        <div className="error-line">
          {showError ? <span>{props.errors[props.name]}</span> : null}
        </div>
      </div>
    </div>
  );
};

export default LabelInsideInputController;
